import { StyleRules } from '@material-ui/core/styles';
import { CardActionAreaClassKey } from '@material-ui/core/CardActionArea';

export const MuiCardActionArea: Partial<StyleRules<CardActionAreaClassKey>> = {
  root: {
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0,
    },
  },
};
